import { Address } from "../models/Address";

export interface AddressDTO {
  "@type": "Address";
  id: number;
  addressType: string;
  street?: string;
  number?: number;
  box?: string;
  zip?: string;
  municipality?: string;
  country?: string;
  cellPhoneNumber?: string;
  email?: string;
  fixedNumber?: string;
}

export const mapToAddressModel = (
  addressDTO: AddressDTO | undefined
): Address => {
  const address: Address = new Address();
  if (addressDTO !== undefined) {
    address.id = addressDTO.id;
    address.street = addressDTO.street;
    address.number = addressDTO.number ? addressDTO.number.toString() : "";
    address.box = addressDTO.box;
    address.zip = addressDTO.zip;
    address.municipality = addressDTO.municipality;
    address.country = addressDTO.country;
    address.cellPhoneNumber = addressDTO.cellPhoneNumber;
    address.email = addressDTO.email;
  }
  return address;
};
